// extracted by mini-css-extract-plugin
export default {"container":"home_box_container__zM+SZ","shadow":"home_box_shadow__t1Gzv","about_container":"home_box_about_container__rHxmA"};